import { ExternalLink, ShoppingBag } from "lucide-react";
import { ButtonLink } from "@/components/ButtonLink";
import { Countdown } from "@/components/Countdown";
import { PageHero } from "@/components/PageHero";
import { useI18n } from "@/i18n/I18nProvider";

export function Buy() {
  const { t } = useI18n();

  return (
    <>
      <PageHero title={t("buy.hero.title")} body={t("buy.hero.body")} image="/concepts/verdantfall-hero.png">
        <div className="hero-actions page-actions">
          <ButtonLink href="/buy" disabled>
            <ShoppingBag size={18} />
            {t("common.steamSoon")}
          </ButtonLink>
        </div>
      </PageHero>

      <section className="release-band">
        <div className="section-inner release-grid">
          <div data-reveal>
            <p className="eyebrow">{t("common.inDevelopment")}</p>
            <h2>{t("buy.release.title")}</h2>
            <p>{t("buy.release.body")}</p>
          </div>
          <Countdown />
        </div>
      </section>

      <section className="content-band">
        <div className="section-inner buy-grid">
          <article className="feature-card purchase-card" data-reveal>
            <ExternalLink size={24} />
            <h3>{t("buy.steam.title")}</h3>
            <p>{t("buy.steam.body")}</p>
            <ButtonLink href="/buy" variant="secondary" disabled>
              {t("common.steamSoon")}
            </ButtonLink>
          </article>
          <article className="feature-card purchase-card" data-reveal>
            <ShoppingBag size={24} />
            <h3>{t("buy.edition.title")}</h3>
            <p>{t("buy.edition.body")}</p>
            <p className="soft-note">{t("buy.notice")}</p>
          </article>
        </div>
      </section>
    </>
  );
}
